import { EmailAddressDto } from '../../data-transfer-objects';

/**
 * Event Types
 */
export enum EmailEventTypes {
  EMAIL_ADDRESS_CREATED = '[Interactable] Email Address Created',
  EMAIL_ADDRESS_UPDATED = '[Interactable] Email Address Updated',
  EMAIL_ADDRESS_DELETED = '[Interactable] Email Address Deleted',
}

/**
 * Payloads
 */
export interface EmailAddressWSPayload {
  emailAddress: EmailAddressDto;
  memberId: string;
}

/**
 * Events
 */
export class EmailAddressWSMessage {
  constructor(
    public type: EmailEventTypes,
    public payload: EmailAddressWSPayload
  ) {}
}
